module.exports = __webpack_public_path__ + "img/grandex.a2ba3d70.svg";